import { intervalToDuration, parseISO } from 'date-fns';
export function toMiles(km) {
    var tdis = parseFloat(`${km}`) * 0.621371;
    return tdis.toFixed(1);
}
export function toKm(mi) {
    var tdis = parseFloat(`${mi}`) / 0.621371;
    return tdis.toFixed(1);
}
export const toMilesRaw = (km) => {
    var tdis = parseFloat(`${km}`) * 0.621371;
    return tdis;
};
export const toKmRaw = (mi) => {
    var tdis = parseFloat(`${mi}`) / 0.621371;
    return tdis;
};
export const nl2br = (text) => {
    const newText = text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    return newText;
};
export const replaceSpaceWithBr = (text) => {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
};
export const replaceBrWithSpace = (text) => {
    return text.replace(/<br\s*[\/]?>/gi, '\n');
};
export const htmltoText = (html) => {
    let text = html;
    text = text.replace(/<style([\s\S]*?)<\/style>/gi, '');
    text = text.replace(/<script([\s\S]*?)<\/script>/gi, '');
    text = text.replace(/<span.*?>/g, ''); // delete span tags
    text = text.replace(/<strong.*?>/g, ''); // delete strong tags
    text = text.replace(/<b.*?>/g, ''); // delete strong tags
    text = text.replace(/<i.*?>/g, ''); // delete italic tags
    text = text.replace(/<small.*?>/g, ''); // delete small tags
    text = text.replace(/<img.*?>/g, ''); // delete image tags
    text = text.replace(/<[^a/](.*?)>/gi, '<br/>'); // replace all remaining opening tags (exept <a>) for <br/>
    text = text.replace(/<[^>(<br/>)]+>/gi, ''); // replace all closing tags
    return text;
};
export function getLanguage(language) {
    switch (language) {
        case 'es_419':
            return 'Spanish';
        case 'de_DE':
            return 'German';
        case 'en_US':
        default:
            return 'English';
    }
}
export const validateNumber = (number) => {
    if (isNaN(number)) {
        return 0;
    }
    else {
        return number;
    }
};
export const addCommaToNumber = (number) => {
    number = validateNumber(Math.round(number * 100) / 100);
    let convertedNumber;
    if (number === null) {
        convertedNumber = 0;
    }
    else if (isNaN(number)) {
        convertedNumber = `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    else {
        convertedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return convertedNumber;
};
export const getDateInterval = (startDate, endDate) => {
    const interval = intervalToDuration({
        start: parseISO(startDate),
        end: parseISO(endDate),
    });
    const validInterval = {
        years: interval.years ?? 0,
        months: interval.months ?? 0,
        days: interval.days ?? 0,
        hours: interval.hours ?? 0,
        minutes: interval.minutes ?? 0,
    };
    let s = '';
    if (validInterval.months > 0 || validInterval.years > 0) {
        // format 1m
        s = `${validInterval.months + validInterval.years * 12}m`;
        if (validInterval.days > 0 || validInterval.hours > 0) {
            // format 1m 2d
            s = s + ` ${validInterval.days}d`;
        }
        if (validInterval.hours > 0) {
            // format 1m 2d 3hr
            s = s + ` ${validInterval.hours}hr`;
        }
    }
    else if (validInterval.days > 0) {
        // format 1d
        s = `${validInterval.days}d`;
        if (validInterval.hours > 0 || validInterval.minutes > 0) {
            // format 1d 2hr
            s = s + ` ${validInterval.hours}hr`;
        }
        if (validInterval.minutes > 0) {
            // format 1d 2hr 3m
            s = s + ` ${validInterval.minutes}min`;
        }
    }
    else if (validInterval.hours > 0) {
        // format 1hr
        s = `${validInterval.hours}hr`;
        if (validInterval.minutes) {
            // format 1hr 2min
            s = s + ` ${validInterval.minutes}min`;
        }
    }
    else if (validInterval.minutes > 0) {
        // format 1min
        s = `${validInterval.minutes}min`;
    }
    return s;
};
export const roundTo2dp = (number) => {
    const parsedNumber = parseFloat(`${Math.round(number * 100) / 100}`);
    if (isNaN(parsedNumber)) {
        return '';
    }
    return `${parsedNumber}`;
};
export const removeAtIndex = (array, index) => {
    const left = array.slice(0, index);
    const right = array.slice(index + 1);
    return [...left, ...right];
};
export const getWordCount = (text) => {
    const wordsArray = text.match(/\S+/g) ?? [];
    return {
        charactersNoSpaces: text.replace(/\s+/g, '').length,
        characters: text.length,
        words: wordsArray.length,
        lines: text.split(/\r*\n/).length,
    };
};
